import FinInstitutions from '@/modules/financials';

export default FinInstitutions;
